var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-users-wrapper" }, [
    _c("div", { attrs: { id: "settings-users-container" } }, [
      _c(
        "ul",
        {
          staticClass: "row tabs settings-users-tabs",
          attrs: { id: "settings-users-tabs", "data-tabs": "" },
        },
        [
          _vm.isHkUserShow
            ? _c(
                "li",
                { staticClass: "tabs-title is-active column tab-size" },
                [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tabsCount > 1,
                          expression: "tabsCount > 1",
                        },
                      ],
                      attrs: { href: "#tab-hkl-user" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("settings.hklUser")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isVendorShow
            ? _c(
                "li",
                {
                  staticClass: "tabs-title column tab-size",
                  class: { "is-active": !_vm.isHkUserShow && _vm.isVendorShow },
                },
                [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tabsCount > 1,
                          expression: "tabsCount > 1",
                        },
                      ],
                      attrs: { href: "#tab-contractor" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("settings.vendor")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enableTenancyRecordsFeature && _vm.isTenancyUserShow
            ? _c("li", { staticClass: "tabs-title column tab-size" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tabsCount > 1,
                        expression: "tabsCount > 1",
                      },
                    ],
                    attrs: { href: "#tab-tenant" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("settings.tenancyUsers")) +
                        "\n        "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "settings-tabs-content",
          attrs: { "data-tabs-content": "settings-users-tabs" },
        },
        [
          _vm.isHkUserShow
            ? _c(
                "div",
                {
                  staticClass: "tabs-panel is-active",
                  attrs: { id: "tab-hkl-user" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "grey lighten-5" },
                    [_c("HklUsers")],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isVendorShow
            ? _c(
                "div",
                {
                  staticClass: "tabs-panel",
                  class: { "is-active": !_vm.isHkUserShow && _vm.isVendorShow },
                  attrs: { id: "tab-contractor" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "grey lighten-5" },
                    [_c("VendorAccounts")],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enableTenancyRecordsFeature && _vm.isTenancyUserShow
            ? _c(
                "div",
                { staticClass: "tabs-panel", attrs: { id: "tab-tenant" } },
                [
                  _c(
                    "div",
                    { staticClass: "grey lighten-5" },
                    [_c("TenancyUsers")],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }